import { Injectable, signal, computed, ChangeDetectorRef } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { StatusCount } from '../../Api/DcoApi/Status/StatusCount'
import { RestClient } from '../../Api/DcoApi/Client/RestClient';
import { PGFilterService } from './PGFilterService';

@Injectable({
  providedIn: 'root' // Das macht den Service zu einem anwendungsweiten Singleton
})
export class StatusCountService {

  private api: RestClient = new RestClient();
  public StatusCount = signal<StatusCount>({
    inBetrieb: 0, inbr: 0, inKlaerung: 0, neu: 0, ruekholung: 0, storno: 0, ueberpruefung: 0, abgeschlossen: 0, beendet: 0, ekv: 0, leitstelle: 0, postversand: 0, unterschriftWartend: 0, versand: 0, welcomcall: 0
  } as StatusCount);
  public dataChanged = this.StatusCount.asReadonly();
  public dataChanged$: Observable<StatusCount> = toObservable(this.StatusCount);

  constructor(private pgService: PGFilterService) {
    this.loadOrUpdateData();
    pgService.dataChanged$.subscribe(async o => { await this.loadOrUpdateData(); })

  }


  public async loadOrUpdateData(): Promise<void> {
    try {


      this.StatusCount.set(await this.api.Get<StatusCount>(`/Backend/Api/V2/Status/Count/${this.pgService.PG()}`) ?? {});


    } catch (error) {
      console.log('Fehler beim Laden der Daten:', error);
      //throw error;
    }
  }



}
